var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25026 5.69244C4.16498 4.65607 5.50649 4 7 4H17C18.2674 4 19.4267 4.47284 20.3076 5.25026C21.3439 6.16498 22 7.50649 22 9V15C22 17.7614 19.7614 20 17 20H7C4.23858 20 2 17.7614 2 15V9C2 7.73263 2.47284 6.57325 3.25026 5.69244ZM5.57252 6.36047L11.9681 11.6734L17.9847 6.16505C17.6764 6.05805 17.3452 6 17 6H7C6.48312 6 5.9971 6.1303 5.57252 6.36047ZM19.5599 7.43449L12.6753 13.7376C12.3066 14.0751 11.7454 14.0886 11.361 13.7692L4.22999 7.84528C4.08173 8.20051 4 8.59036 4 9V15C4 16.6569 5.34315 18 7 18H17C18.6569 18 20 16.6569 20 15V9C20 8.42619 19.8394 7.8904 19.5599 7.43449Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.25e5199f0f402c0c75c9ccdb07507007.svg";
export { ForwardRef as ReactComponent };